import { Link } from 'react-router-dom';
import { Check } from '../Icons';

export default function Pricing() {
  return (
    <section id="pricing" className="section container">
      <div className="pricing__head">
        <h2 className="pricing__title">Start free. Upgrade when you're ready.</h2>
      </div>

      <div className="pricing__grid">
        {/* Free */}
        <div className="plan plan--free">
          <div className="plan__eyebrow">Free</div>
          <div className="plan__price-row">
            <span className="plan__price">£0</span>
          </div>
          <p className="plan__desc">
            <strong>Just starting a business?</strong> Know exactly what you need and tick it off
            yourself, perfect before your first hire.
          </p>
          <div className="plan__features">
            <span className="plan__feature">
              <Check size={17} /> Your tailored document requirements
            </span>
            <span className="plan__feature">
              <Check size={17} /> Must-have vs should-have guidance
            </span>
            <span className="plan__feature">
              <Check size={17} /> Document templates to start from
            </span>
            <span className="plan__feature">
              <Check size={17} /> See what you're missing at a glance
            </span>
          </div>
          <Link to="/waitlist" className="plan__cta btn-rose-soft">
            Start for free
          </Link>
        </div>

        {/* Business (featured) */}
        <div className="plan plan--pro">
          <div className="plan__eyebrow">Business</div>
          <div className="plan__price-row">
            <span className="plan__price">£50</span>
            <span className="plan__price-suffix">/mo</span>
          </div>
          <span className="plan__price-terms">up to 4 employees</span>
          <div className="plan__scale">
            <span className="plan__scale-label">As your team grows</span>
            <div className="plan__scale-row">
              <span>5–9 employees</span>
              <span className="plan__scale-price">£75/mo</span>
            </div>
            <div className="plan__scale-row">
              <span>10–20 employees</span>
              <span className="plan__scale-price">£100/mo</span>
            </div>
            <div className="plan__scale-row">
              <span>20+ employees</span>
              <Link to="/waitlist" className="plan__scale-link">
                Contact us
              </Link>
            </div>
          </div>
          <p className="plan__desc">
            Your full HR copilot for a small team. We do the checking, watch the law and answer your
            questions, every month.
          </p>
          <div className="plan__features">
            <span className="plan__feature">
              <Check size={17} color="#A7C79D" /> Everything in Free
            </span>
            <span className="plan__feature">
              <Check size={17} color="#A7C79D" /> Every document and policy checked for you, ongoing
            </span>
            <span className="plan__feature">
              <Check size={17} color="#A7C79D" /> An AI assistant based on your policies, UK law, and ACAS guidance
            </span>
            <span className="plan__feature">
              <Check size={17} color="#A7C79D" /> Always instantly available, even at 2am on a Sunday
            </span>
          </div>
          <Link to="/waitlist" className="plan__cta btn-primary" style={{ boxShadow: 'none' }}>
            Get started
          </Link>
        </div>

        {/* Portfolio */}
        <div className="plan plan--free">
          <div className="plan__eyebrow">
            Portfolio <span className="plan__new">new</span>
          </div>
          <div className="plan__price-row">
            <span className="plan__price plan__price--text">One price for your whole portfolio</span>
          </div>
          <span className="plan__price-terms">
            The Business tiers, on your combined headcount, not per company.
          </span>
          <div className="plan__example">
            3 companies of 3 people each? You pay <strong>£+75/mo, not £150</strong>.
          </div>
          <p className="plan__desc">
            Running HR for several companies? Add them all to one account and pay on your combined
            team size, so a portfolio of small companies costs a fraction of paying per company.
          </p>
          <div className="plan__features">
            <span className="plan__feature">
              <Check size={17} /> Everything in Business, for every company
            </span>
            <span className="plan__feature">
              <Check size={17} /> One account, one bill
            </span>
            <span className="plan__feature">
              <Check size={17} /> A compliance view across your whole portfolio
            </span>
            <span className="plan__feature">
              <Check size={17} /> Built for consultants, accountants and multi-site owners
            </span>
          </div>
          <Link to="/waitlist" className="plan__cta btn-rose-soft">
            Register interest
          </Link>
        </div>
      </div>

      <div className="pricing__escalate">
        <span className="pricing__escalate-text">
          <strong>Real expert advice, on demand.</strong> Escalate any case to a CIPD-qualified
          professional.
        </span>
        <span className="pricing__escalate-price">Pricing TBD</span>
      </div>
    </section>
  );
}
